import Hero from '../components/Hero'
import DonationCTA from '../components/DonationCTA'
import LogoTicker from '../components/LogoTicker'
import PayPalCTA from '../components/PayPalCTA'
import TestimonialTicker from '../components/TestimonialTicker'


export default function Donar() {

  const sampleTestimonials = [
    {
      quote: "La Gaviota ha transformado la vida de mi hijo. El equipo es increíble y el progreso que hemos visto es notable.",
      author: "María González"
    },
    {
      quote: "Gracias a las terapias y el apoyo constante, mi hija ha logrado avances que nunca imaginamos posibles.",
      author: "Juan Pérez"
    },
    {
      quote: "El ambiente inclusivo y el profesionalismo del personal hacen de La Gaviota un lugar único para el desarrollo de los niños.",
      author: "Ana Martínez"
    },
    {
      quote: "No solo ayudan a los niños, sino que también nos apoyan a los padres con orientación y herramientas valiosas.",
      author: "Carlos Rodríguez"
    }
  ];

  return (
    <article className="w-full overflow-x-hidden">
      {/* Hero Section */}
      <Hero 
        title="Porque entre dos es mejor"
        backgroundImage="/images/banners/arts_gaviota.jpg"
      />

      {/* Donation CTA */}
      <DonationCTA />

      {/* PayPal CTA */}
      <div className="mb-16 md:mb-32 -mt-8 md:-mt-16">
        <PayPalCTA text="Aporta a la causa con PayPal" />
      </div>

      {/* Testimonial Ticker */}
      <TestimonialTicker testimonials={sampleTestimonials} />

      {/* Decorative Banner */}
      <div
        className="w-screen h-[50vh] md:h-[75vh] mb-16 md:mb-32"
        style={{
          width: '100vw',
          marginLeft: 'calc(-50vw + 50%)',
          backgroundImage: 'url("/images/banners/doctors_gaviota.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
        role="img"
        aria-label="Decorative Banner"
      />

      {/* Administrar CTA */}
      <div className="w-screen relative left-[50%] right-[50%] ml-[-50vw] mr-[-50vw] pb-16 md:pb-32">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
          <div className="bg-white rounded-lg p-6 md:p-12 flex flex-col md:flex-row items-center gap-8 md:gap-12">
            {/* Left side - Image */}
            <div className="w-full md:w-1/2">
              <div 
                className="w-full aspect-[4/3] rounded-lg"
                style={{
                  backgroundImage: 'url("/images/banners/panaderia_gaviota.jpg")',
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  backgroundColor: '#e5e7eb'
                }}
                role="img"
                aria-label="PayPal Donation Banner"
              />
            </div>
            
            {/* Right side - Content */}
            <div className="w-full md:w-1/2 flex flex-col gap-4 md:gap-6">
              <h2 className="headline-large text-center md:text-left">¿Llevas un plan de donaciones?</h2>
              <p className="body-medium text-gray-600 text-center md:text-left">
                Administra tus planes de donación de manera segura y sencilla a través de Stripe.
              </p>
              <a 
                href="https://billing.stripe.com/p/login/aEU00A4028TCe3ebII"
                target="_blank"
                rel="noopener noreferrer"
                className="w-full md:w-fit flex items-center justify-center gap-3 px-6 py-4 text-white bg-[#003CFF] rounded-lg transition-all duration-300 hover:bg-black hover:px-8 hover:text-white"
              >
                <span className="body">Administrar tus planes →</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Logo Ticker */}
      <div className="mb-16 md:mb-32">
        <LogoTicker />
      </div>
    </article>
  )
} 